<template>
  <router-link class="profile" :to="{ name: 'profile.index'}">
    <template v-if="status != 'guest'">
      <figure class="profile__avatar">
        <img v-if="user.profile_pic !== false" :src="user.profile_pic">

      </figure>
      <div class="profile__name">
        <div>{{ user.name }}</div>
        <div v-if="typeof user.company !== 'undefined' && user.company !== null"> {{ user.company.name }}</div>
      </div>
    </template>
  </router-link>
</template>

<script>
export default {
  props: ['status'],
  methods: {
    showModal () {
      this.$store.commit('setProfileEditModal', true)
    }
  }
}
</script>
